import { takeEvery, call, select, put, race, delay } from 'redux-saga/effects'

import { actionCreators } from '@/duck/dashboard'
import { actionCreators as panelActionCreators } from '@/duck/panel'
import { selectUser } from '@/selector'
import { guid } from '@/util'
import api from '@/api'

function* queryIndicator(action) {
    const { params, resolve, reject } = action.payload
    const { layerName } = params
    try {
        const response = yield call(api.indicator, layerName)
        resolve(response)
    } catch (e) {
        reject(e)
    }
}

export function* watchQueryIndicator() {
    yield takeEvery(actionCreators.dashboard.panel.query.indicator, queryIndicator)
}

function* querySituation(action) {
    const { params, resolve, reject } = action.payload
    const { layerName, passageDate } = params
    try {
        const response = yield call(api.situation, layerName, passageDate)
        resolve(response)
    } catch (e) {
        reject(e)
    }
}

export function* watchQuerySituation() {
    yield takeEvery(actionCreators.dashboard.panel.query.situation, querySituation)
}

function* queryTemperature(action) {
    const { params, resolve, reject } = action.payload
    const { date, point } = params
    try {
        const response = yield call(api.temperature, date, point.lng, point.lat)
        resolve(response)
    } catch (e) {
        reject(e)
    }
}

export function* watchQueryTemperature() {
    yield takeEvery(actionCreators.dashboard.panel.query.temperature, queryTemperature)
}

function* queryOrder(action) {
    const { params, resolve, reject } = action.payload
    const { userId, page } = params
    try {
        const response = yield call(api.order, userId, page)
        resolve(response)
    } catch (e) {
        reject(e)
    }
}

export function* watchQueryOrder() {
    yield takeEvery(actionCreators.dashboard.panel.query.order, queryOrder)
}

function* queryOperation(action) {
    yield put(panelActionCreators.panel.operation.status({ status: 'loading' }))
    const { point, size } = action.payload
    const user = yield select(selectUser)
    const status = yield call(api.operationStatus)
    if (!status.result) {
        yield put(panelActionCreators.panel.operation.status({ status: 'fullfill' }))
        return
    }
    const uuid = guid()
    const { response, timeout } = yield race({
        response: call(api.operation, point, size, user, uuid),
        timeout: delay(1000)
    })
    if (timeout) {
        yield call(api.saveSize, uuid, size)
        yield put(panelActionCreators.panel.operation.version())
        yield put(panelActionCreators.panel.operation.status({ status: 'success' }))
    }
}

export function* watchQueryOperation() {
    yield takeEvery(actionCreators.dashboard.panel.query.operation, queryOperation)
}


function* queryOperationImage(action) {
    const user = yield select(selectUser)
    const { params, resolve, reject } = action.payload
    const { uuid } = params
    try {
        const response = yield call(api.operationImage, user.id, uuid)
        resolve(response)
    } catch (e) {
        reject(e)
    }
}

export function* watchQueryOperationImage() {
    yield takeEvery(actionCreators.dashboard.panel.query.image, queryOperationImage)
}

function* querySize(action) {
    const { params, resolve, reject } = action.payload
    const { uuid } = params
    try {
        const response = yield call(api.querySize, uuid)
        resolve(response)
    } catch (e) {
        reject(e)
    }
}

export function* watchQuerySize() {
    yield takeEvery(actionCreators.dashboard.panel.query.size, querySize)
}